import React from "react";
import { ShieldCheck } from "@phosphor-icons/react";
import MfaEnableFlow from "./mfa/MfaEnableFlow";
import MfaDisableFlow from "./mfa/MfaDisableFlow";

/** MFA setup / disable widget. Meant to be embedded inside Profile. */
export default function MfaCard({ user, onChange }) {
  return (
    <div className="brut-card p-6" data-testid="mfa-card">
      <div className="flex items-center justify-between">
        <div>
          <div className="font-chivo font-bold uppercase tracking-tight">Multi-factor authentication</div>
          <div className="text-xs text-zinc-600 mt-1">Time-based one-time passwords (TOTP)</div>
        </div>
        <div className="text-[11px] uppercase tracking-widest">
          {user?.mfa_enabled ? (
            <span className="bg-black text-white px-2 py-1 border border-black inline-flex items-center gap-1">
              <ShieldCheck size={12} weight="fill" /> Enabled
            </span>
          ) : (
            <span className="border border-black px-2 py-1">Disabled</span>
          )}
        </div>
      </div>

      {user?.mfa_enabled
        ? <MfaDisableFlow onDisabled={onChange} />
        : <MfaEnableFlow onEnabled={onChange} />}
    </div>
  );
}
